export default "__VITE_ASSET__ChXZXQbv__"